export default __webpack_public_path__ + "a5c544d1b9fe3dc80da682677ab674f4.mp3";